import { Button, Row } from "antd";
import { usePermissions } from "../../../../../../../../../lib/hooks/usePermissions";
import { IPayersGet } from "../../../../../../../../../types/Payer";
import { useMemo } from "react";
import { PercentageWarning } from "../../../../../../../../../components/PercentageWarning";

type HeaderProps = {
  data: IPayersGet[];
  isLoading: boolean;
  onAddClick: () => void;
};

export const Header = ({ data, isLoading, onAddClick }: HeaderProps) => {
  const { hasAccessByController } = usePermissions("ContractPayers");

  const activePercent: number = useMemo(() => {
    const active: IPayersGet[] = data.filter(
      (item: IPayersGet) => item.status === 0,
    );

    if (active.length > 0) {
      return active.reduce(
        (sum: number, item: IPayersGet) => sum + item.percentage,
        0,
      );
    }

    return -1;
  }, [data]);

  return (
    <Row className="w-100">
      <Row className="w-100 justify-space-between align-center mb-6">
        <h5 className="h h5 ant-table-title">Payers</h5>
        <Row className="align-center">
          <p className="ma-0 text-md title">Used for Tax 1098</p>
          {hasAccessByController("Add") && (
            <Button shape="round" className="ml-4" onClick={onAddClick}>
              Add New
            </Button>
          )}
        </Row>
      </Row>
      {!isLoading && activePercent >= 0 && activePercent !== 100 && (
        <PercentageWarning value={activePercent} />
      )}
    </Row>
  );
};
